module.exports = __webpack_public_path__ + "images/backgrounds/bricks.5e21dfb838e99d8a7c54.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/backgrounds/bricks.png
// module id = Rtmh
// module chunks = 13